export const COMMON_FILTERS_COMPONENTS = {
	BLANK: 'blank',
	OFFICE_PICKUP: 'officePickup',
	OFFICE_DROPOFF: 'officeDropoff',
	MAIN_SITE: 'mainSite',
	SITE: 'site',
	BROKERS: 'brokers',
	MAIN_PROVIDER: 'mainProvider',
	PROVIDERS: 'providers',
	EXTRA_PROVIDERS: 'extraProviders',
	WEB_SUPPLIERS: 'webSuppliers',
	WEB_SUPPLIER_TOGGLE: 'webSuppliersToggle',
	EXCLUDE_WEB_SUPPLIERS: 'excludeWebSuppliers',
	TIERS: 'tiers',
	CATEGORIES: 'categories',
	EXTRA_CATEGORIES: 'extraCategories',
	RENTAL_DATES: 'rentalDates',
	DATE_RANGE: 'dateRange',
	DATES: 'dates',
	SINGLE_DATE: 'singleDate',
	RENTAL_LENGTH: 'rentalLength',
	RENTAL_LENGTH_SELECT: 'rentalLengthSelect',
	RENTAL_LENGTH_TAGS: 'rentalLengthTags',
	BOOKING_DATE: 'bookingDate',
	START_HOUR: 'startHour',
	END_HOUR: 'endHour',
	ANALYZER_ACRISS: 'analyzerAcriss',
	CURRENCY: 'currency',
	USERS: 'users',
	DAILY_PRICE: 'dailyPrice',
	DAILY_PRICE_TOGGLE: 'dailyPriceToggle',
	PRICE_KPI: 'priceKpi',
	ACRISS: 'acriss',
	MILEAGE: 'mileage',
	MILEAGE_SELECT: 'mileageSelect',
	TRANSMISSION: 'transmission',
	TRANSMISSION_SELECT: 'transmissionSelect',
	FUEL_POLICY: 'fuelPolicy',
	FUEL_POLICY_SELECT: 'fuelPolicySelect',
	INSURANCE: 'insurance',
	INSURANCE_SELECT: 'insuranceSelect',
	PREPAID: 'prepaid',
	PREPAID_SELECT: 'prepaidSelect',
	IN_TERMINAL: 'inTerminal',
	IN_TERMINAL_SELECT: 'inTerminalSelect',
	GROUP_BY: 'groupBy',
	HOW_TO_GROUP: 'howToGroup',
	IS_PREV_COMPARISON: 'isPrevComparison',
	PREV_COMPARISON: 'prevComparison',
	SHOW_FEATURES: 'showFeatures',
	SHOW_DROPOFF: 'showDropoff',
	BOOKING_WEEKS: 'bookingWeeks',
	MARKETS: 'markets',
	SITE_MARKET_TOGGLE: 'siteMarketToggle',
    IS_OFFICE_GROUP: 'isOfficeGroup',
    OFFICE_GROUP: 'officeGroup',
    IS_SITE_GROUP: 'isSiteGroup',
    SITE_GROUP: 'siteGroup',
	MAIN_SITE_PROVIDER_TOGGLE: 'mainSiteProviderToggle',
}